<template>
  <div>
    <OfflineIndicator />
    <router-view />
    <PwaUpdatePrompt />
  </div>
</template>

<script>
import PwaUpdatePrompt from './components/PwaUpdatePrompt.vue'
import OfflineIndicator from './components/OfflineIndicator.vue'

export default {
  name: 'App',
  components: {
    PwaUpdatePrompt,
    OfflineIndicator
  }
}
</script>

<style>
</style>
